import React from 'react';

interface SkeletonLoaderProps {
  type?: 'text' | 'card' | 'table' | 'form';
  rows?: number;
  className?: string;
}

export function SkeletonLoader({ type = 'text', rows = 3, className = '' }: SkeletonLoaderProps) {
  const baseClass = 'animate-pulse bg-gray-200 rounded';

  if (type === 'text') {
    return (
      <div className={`space-y-3 ${className}`}>
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className={`h-4 ${baseClass} ${i === rows - 1 ? 'w-3/4' : 'w-full'}`} />
        ))}
      </div>
    );
  }

  if (type === 'card') {
    return (
      <div className={`${className}`}>
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className={`p-4 mb-4 bg-white rounded-xl shadow-sm`}>
            <div className="flex items-center space-x-4 space-x-reverse">
              <div className={`w-12 h-12 rounded-full ${baseClass}`} />
              <div className="flex-1 space-y-2">
                <div className={`h-4 ${baseClass} w-1/2`} />
                <div className={`h-3 ${baseClass} w-3/4`} />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (type === 'table') {
    return (
      <div className={`${className}`}>
        <div className={`h-10 ${baseClass} w-full mb-4`} />
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className={`h-12 ${baseClass} w-full mb-2`} />
        ))}
      </div>
    );
  }

  if (type === 'form') {
    return (
      <div className={`space-y-4 ${className}`}>
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i}>
            <div className={`h-4 ${baseClass} w-24 mb-2`} />
            <div className={`h-10 ${baseClass} w-full`} />
          </div>
        ))}
      </div>
    );
  }

  return null;
}
